<template>
  <div id="addEmployee" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="catalogo"
    >
      <v-row no-gutters class="titulo catalogoTitle"
        >Catálogo de Empleados</v-row
      >

      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-3"
          >¿La estructura organizacional será por?</v-col
        >
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select name="estructura" id="estructura" v-model="estructura">
            <option disabled value="0">Selecciona estructura</option>
            <option
              v-for="carga in structure"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3" v-if="estructura == 2"
          >Empresa Pagadora</v-col
        >
        <v-col cols="12" sm="4" class="py-3 selectGris" v-if="estructura == 2">
          <select name="pagadora" id="pagadora" v-model="enterprise">
            <option disabled value="0">Selecciona</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3">¿El tipo de carga?</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select name="location" id="location" v-model="carga">
            <option disabled value="0">Selecciona carga</option>
            <option
              v-for="carga in cargas"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-1" v-if="carga == 2">
          <p style="font-size: 18px">
            <i style="color: #0f6c21" class="fas fa-file-excel"></i>
            <a href="#" @click="descargaExcel()">&nbsp;&nbsp;Descargar</a>
            plantilla de excel para llenar.
          </p>
        </v-col>

        <v-col cols="12" sm="12" class="uploadfile py-2" v-if="carga == 2">
          Subir archivo de Excel con la lista de empleados a registrar.
          <input
            type="file"
            id="archivo"
            lang="es"
            ref="fileUploadPerfilEdit"
            @click="resetFile"
            @change="previewFiles($event)"
          />
        </v-col>
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacionCatalogo()">Siguiente</button>
          <router-link to="/employeesList">
            <button class="boton">Regresar</button>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="dataEmpleado"
    >
      <v-row no-gutters class="titulo">Agregar Empleado</v-row>

      <v-row no-gutters class="datos">
        <v-col class="py-2 mt-9" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="enterprise">Empresa</label>
            <select
              name="enterprise"
              id="enterprise"
              v-model="enterprise"
              @change="obtenerAreasPuestos()"
            >
              <option disabled value="0">Selecciona</option>
              <option
                v-for="enterprise in enterprises"
                :key="enterprise.id"
                v-bind:value="enterprise.id"
              >
                {{ enterprise.razonSocial }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2 mt-9" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="branch">Sucursal</label>
            <select name="select2" id="select2" v-model="branch">
              <option disabled value="0">Selecciona Sucursal</option>
              <option
                v-for="branch in branches"
                :key="branch.id"
                v-bind:value="branch.id"
              >
                {{ branch.nombreSucursal }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="area">Área</label>
            <select name="area" id="area" v-model="area">
              <option value="0">Selecciona Area/Depto</option>
              <option
                v-for="area in areas"
                :key="area.id"
                v-bind:value="area.id"
              >
                {{ area.nombreArea }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="job">Puesto</label>
            <select id="job" name="job" v-model="job">
              <option disabled value="0">Selecciona Puesto</option>
              <option v-for="job in jobs" :key="job.id" v-bind:value="job.id">
                {{ job.nombrePuesto }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="sueldo">Sueldo</label>
            <input
              type="text"
              name="sueldo"
              id="sueldo"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="pay"
              required
              maxlength="5"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="dateAdmission">Fecha de Admisión</label>
            <input
              type="date"
              name="dateAdmission"
              id="dateAdmission"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dateAdmission"
              required
              maxlength="20"
            />
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="my-5"
          >Datos Personales</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="name">Nombre</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="name"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
              @blur="
                nombreCompuesto();
                answer();
              "
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="surname">Apellido Paterno</label>
            <input
              type="text"
              name="surname"
              id="surname"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="surname"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
              @blur="
                quitaArticulosPaterno();
                answer();
              "
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="lastName">Apellido Materno</label>
            <input
              type="text"
              name="lastName"
              id="lastName"
              class="inputs"
              autocomplete="false"
              v-model="lastName"
              maxlength="20"
              @keypress="alfaNumerico($event)"
              @blur="
                quitaArticulosMaterno();
                answer();
              "
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="date">Fecha de Nacimiento</label>
            <input
              type="date"
              name="date"
              id="date"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="date"
              required
              maxlength="20"
              @blur="answer()"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="curp">CURP</label>
            <input
              type="text"
              name="curp"
              id="curp"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              required
              v-model="curp"
              maxlength="18"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="rfc">RFC</label>
            <input
              type="text"
              name="rfc"
              id="rfc"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              required
              v-model="rfc"
              maxlength="13"
              @keypress="validaRfc($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="imss">IMSS</label>
            <input
              type="text"
              name="imss"
              id="imss"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="imss"
              required
              maxlength="11"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Siguiente
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="dataCfdi"
    >
      <v-row no-gutters class="titulo">Datos CFDI</v-row>

      <v-row no-gutters class="datos">
        <v-col class="mt-11 mb-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="typeContract">Tipo de Contrato</label>
            <select name="typeContract" id="typeContract" v-model="contract">
              <option selected disabled value="0">Selecciona Contrato</option>
              <option
                v-for="contract in contracts"
                :key="contract.id"
                v-bind:value="contract.id"
              >
                {{ contract.tipoContrato }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="mt-11 mb-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="typeDay">Tipo de Jornada</label>
            <select name="typeDay" id="typeDay" v-model="day">
              <option disabled value="0">Selecciona Jornada</option>
              <option v-for="day in days" :key="day.id" v-bind:value="day.id">
                {{ day.nombreJornada }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="risk">Riesgo del Puesto</label>
            <select name="risk" id="risk" v-model="risk">
              <option disabled value="0">Selecciona Riesgo</option>
              <option
                v-for="risk in risks"
                :key="risk.id"
                v-bind:value="risk.id"
              >
                {{ risk.nombreRiesgo }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="union">Sindicalizado</label>
            <select name="union" id="union" v-model="union">
              <option disabled value="0">Selecciona Sindicalizado</option>
              <option selected value="1">Si</option>
              <option value="2">No</option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="regime">Tipo de Régimen</label>
            <select name="regime" id="regime" v-model="regime">
              <option disabled value="0">Selecciona Regimen</option>
              <option
                v-for="regime in regimes"
                :key="regime.id"
                v-bind:value="regime.id"
              >
                {{ regime.nombreRegimen }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="periodicity">Periodicidad de pago</label>
            <select name="periodicity" id="periodicity" v-model="periodicity">
              <option disabled value="0">Selecciona Periodicidad</option>
              <option
                v-for="periodicity in periodicities"
                :key="periodicity.id"
                v-bind:value="periodicity.id"
              >
                {{ periodicity.nombrePeriodicidad }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="labor">Antiguedad</label>
            <input
              type="text"
              name="labor"
              id="labor"
              placeholder="Obligatorio"
              class="inputs mr-2"
              autocomplete="false"
              v-model="labor"
              required
              maxlength="1"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="my-5"
          >Datos Bancarios</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="bank">Banco</label>
            <select name="bank" id="bank" v-model="bank">
              <option disabled value="0">Selecciona Banco</option>
              <option
                v-for="bank in banks"
                :key="bank.id"
                v-bind:value="bank.id"
              >
                {{ bank.nombreCorto }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="count">Cuenta</label>
            <input
              type="text"
              name="count"
              id="count"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="count"
              required
              maxlength="10"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="key">Cuenta clabe</label>
            <input
              type="text"
              name="key"
              id="key"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="key"
              required
              maxlength="18"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="nomina">Anticipo de nómina</label>
            <select name="nomina" id="nomina" v-model="nomina">
              <option selected disabled value="0">Selecciona anticipo</option>
              <option value="1">Si</option>
              <option value="2">No</option>
            </select>
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="
                dataCfdi = false;
                dataEmpleado = true;
              "
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacionCfdi()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!--Error-->
    <v-dialog v-model="error" width="400">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            {{ respuesta }}
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="cancelar()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "6-N",
      check: false,
      show: false,
      error: false,
      errors: [],
      respuesta: "",
      enterprises: [],
      enterprise: 0,
      jobs: [],
      job: 0,
      areas: [],
      area: 0,
      dataCfdi: false,
      dataEmpleado: false,
      //Datos Empleado
      name: "",
      surname: "",
      lastName: "",
      date: "",
      curp: "",
      rfc: "",
      imss: "",
      dateAdmission: "",
      pay: 0,
      //dialogs de empleado
      confirmation: false,
      advice: false,
      //Data CFDI
      labor: "",
      union: 2,

      //Arrays para CFDI

      contracts: [],
      contract: 0,
      days: [],
      day: 0,
      risks: [],
      risk: 0,
      regimes: [],
      regime: 0,
      periodicities: [],
      periodicity: 0,
      banks: [],
      bank: 0,
      //Datos Bancobank: ""
      count: "",
      key: "",
      nomina: 2,
      auxName: "",
      auxSurname: "",
      auxLastName: "",
      message: "",
      branch: 0,
      branches: [],
      catalogo: true,
      estructura: 0,
      structure: [
        {
          id: 1,
          nombre: "Empresa Comercial",
        },
        {
          id: 2,
          nombre: "Empresa Pagadora",
        },
      ],
      carga: 0,
      cargas: [
        {
          id: 1,
          nombre: "Manual",
        },
        {
          id: 2,
          nombre: "Automatica",
        },
      ],
    };
  },
  methods: {
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$"); // Letras y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else return true;
    },
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacionCatalogo() {
      this.errors = [];
      if (this.estructura == 0 || this.carga == 0) {
        this.errors.push(
          "Debe especificar la estructura organizacional y/o el tipo de carga"
        );
      }
      if (this.estructura == 2) {
        if (this.enterprise == 0 || this.enterprise == null)
          this.errors.push("Debe especificar la empresa pagadora.");
      }
      if (this.estructura == 2 && this.carga == 2) {
        if (!this.selectedFile)
          this.errors.push("Debes ingresar un archivo válido.");
      }
      if (this.errors.length == 0) {
        if (this.carga == 2) {
          if (this.estructura == 1)
            this.enterprise = localStorage.idCommercialEnterprise;
          this.procesarExcel();
        } else {
          this.catalogo = false;
          this.dataEmpleado = true;
        }
      } else {
        this.titulo = "Catálogo de empleados";
        this.error = true;
      }
    },
    validacion() {
      console.log("ID DE LA EMPRESA ES: " + this.enterprise);
      this.errors = [];
      this.validaCurp();
      this.validaRfc();
      this.validaImss();
      this.message = "Datos de Empleado";
      if (this.name == "" || this.name == " ") {
        this.errors.push("Se debe especificar el nombre del empleado.");
      }
      if (this.surname == "" || this.surname == " ") {
        this.errors.push("Se debe especificar el apellido paterno.");
      }
      if (this.date == "") {
        this.errors.push("Se debe especificar la fecha de nacimiento.");
      }
      if (this.job == 0 || this.job == "") {
        this.errors.push("Se debe especificar el puesto.");
      }
      if (this.area == "" || this.area == 0) {
        this.errors.push("Se debe especificar el area.");
      }
      if (this.dateAdmission == "") {
        this.errors.push("Se debe especificar la fecha de admisión.");
      }
      if (this.pay == "" && this.pay == 0) {
        this.errors.push("Se debe especificar el sueldo.");
      }
      if (this.errors.length == 0) {
        /*
        this.dataEmpleado = false;
        this.dataCfdi = true;
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }*/
        this.message = "Alerta";
        this.respuesta = "¿Desea almacenar el empleado?";
        this.advice = true;
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    validaCurp() {
      var strCorrecta = this.curp;
      if (strCorrecta.length === 18) {
        return true;
      } else {
        this.errors.push("El CURP esta incompleto favor de verificarlo.");
        return false;
      }
    },
    validaRfc() {
      var strCorrecta;
      strCorrecta = this.rfc;
      if (this.rfc.length == 12) {
        var valid = "^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      } else {
        var valid =
          "^(([A-Z]|[a-z]|s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      }
      var validRfc = new RegExp(valid);
      var matchArray = strCorrecta.match(validRfc);
      if (matchArray == null) {
        this.errors.push("El RFC es incorrecto favor de verificarlo.");
        return false;
      } else {
        console.log("Correcto");
        return true;
      }
    },
    validaImss() {
      console.log(this.imss);
      var imss = this.imss;
      if (imss.length != 11) {
        this.errors.push("Número de IMSS incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(imss.length);
        return false;
      }
    },
    validaKey() {
      console.log(this.key);
      var key = this.key;
      if (key.length != 18) {
        this.errors.push("Número de Cuenta Clave incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(key.length);
        return false;
      }
    },
    validaCount() {
      console.log(this.count);
      var count = this.count;
      if (count.length != 10) {
        this.errors.push("Número de Cuenta incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(count.length);
        return false;
      }
    },
    quitaArticulos(nombre) {
      this.auxName = nombre;
      console.log("quitar ARTICULOS nombre compuesto" + this.auxName);
      this.auxName = this.auxName
        .replace("LA ", "")
        .replace("DE ", "")
        .replace("SA DE CV", "")
        .replace("LOS ", "")
        .replace("LAS ", "")
        .replace("Y ", "")
        .replace("MC ", "")
        .replace("SA ", "")
        .replace("VON ", "")
        .replace("CIA ", "")
        .replace("DEL ", "")
        .replace("SOC ", "")
        .replace("COOP ", "")
        .replace("A EN P ", "")
        .replace("MAC ", "")
        .replace("S EN C ", "")
        .replace("VAN ", "")
        .replace("EN ", "")
        .replace("MI ", "")
        .replace("CON ", "")
        .replace("SUS ", "")
        .replace("SC ", "")
        .replace("SCS ", "")
        .replace("THE ", "")
        .replace("AND ", "")
        .replace("CO ", "")
        .replace("A ", "")
        .replace("SA DE CV MI ", "")
        .replace("COMPA&ÍA ", "")
        .replace("SRL MI", "");
      console.log("sin articulos" + this.auxName);
      return this.auxName;
    },
    quitaArticulosPaterno() {
      this.auxSurname = this.surname.toUpperCase();
      console.log("quitar ARTICULOS apellido Paterno" + this.auxSurname);
      this.auxSurname = this.auxSurname
        .replace("LA ", "")
        .replace("DE ", "")
        .replace("SA DE CV", "")
        .replace("LOS ", "")
        .replace("LAS ", "")
        .replace("Y ", "")
        .replace("MC ", "")
        .replace("SA ", "")
        .replace("VON ", "")
        .replace("CIA ", "")
        .replace("DEL ", "")
        .replace("SOC ", "")
        .replace("COOP ", "")
        .replace("A EN P ", "")
        .replace("MAC ", "")
        .replace("S EN C ", "")
        .replace("VAN ", "")
        .replace("EN ", "")
        .replace("MI ", "")
        .replace("CON ", "")
        .replace("SUS ", "")
        .replace("SC ", "")
        .replace("SCS ", "")
        .replace("THE ", "")
        .replace("AND ", "")
        .replace("CO ", "")
        .replace("A ", "")
        .replace("SA DE CV MI ", "")
        .replace("COMPA&ÍA ", "")
        .replace("SRL MI", "");
      console.log("sin articulos" + this.auxSurname);
      return this.auxSurname;
    },
    quitaArticulosMaterno() {
      this.auxLastName = this.lastName.toUpperCase();
      console.log("quitar ARTICULOS apellido Paterno" + this.auxSurname);
      this.auxLastName = this.auxLastName
        .replace("LA ", "")
        .replace("DE ", "")
        .replace("SA DE CV", "")
        .replace("LOS ", "")
        .replace("LAS ", "")
        .replace("Y ", "")
        .replace("MC ", "")
        .replace("SA ", "")
        .replace("VON ", "")
        .replace("CIA ", "")
        .replace("DEL ", "")
        .replace("SOC ", "")
        .replace("COOP ", "")
        .replace("A EN P ", "")
        .replace("MAC ", "")
        .replace("S EN C ", "")
        .replace("VAN ", "")
        .replace("EN ", "")
        .replace("MI ", "")
        .replace("CON ", "")
        .replace("SUS ", "")
        .replace("SC ", "")
        .replace("SCS ", "")
        .replace("THE ", "")
        .replace("AND ", "")
        .replace("CO ", "")
        .replace("A ", "")
        .replace("SA DE CV MI ", "")
        .replace("COMPA&ÍA ", "")
        .replace("SRL MI", "");
      console.log("sin articulos" + this.auxLastName);
      return this.auxLastName;
    },
    vocales(letra) {
      if (
        letra == "A" ||
        letra == "E" ||
        letra == "I" ||
        letra == "O" ||
        letra == "U" ||
        letra == "a" ||
        letra == "e" ||
        letra == "i" ||
        letra == "o" ||
        letra == "u"
      )
        return true;
      else return false;
    },
    palabraInconveniente(palabra) {
      palabra = palabra
        .replace("BUEI", "BUEX")
        .replace("KOGE", "KOGX")
        .replace("BUEY", "BUEX")
        .replace("KOJO", "KOJX")
        .replace("CACA", "CACX")
        .replace("KAKA", "KAKX")
        .replace("CACO", "CACX")
        .replace("KULO", "KULX")
        .replace("CAGA", "CAGX")
        .replace("MAME", "MAMX")
        .replace("CAGO", "CAGX")
        .replace("MAMO", "MAMX")
        .replace("CAKA", "CAKX")
        .replace("MEAR", "MEAX")
        .replace("COGE", "COGX")
        .replace("MEON", "MEOX")
        .replace("COJA", "COJX")
        .replace("MION", "MIOX")
        .replace("COJE", "COJX")
        .replace("MOCO", "MOCX")
        .replace("COJI", "COJX")
        .replace("MULA", "MULX")
        .replace("COJO", "COJX")
        .replace("PEDA", "PEDX")
        .replace("CULO", "CULX")
        .replace("PEDO", "PEDX")
        .replace("FETO", "FETX")
        .replace("PENE", "PENX")
        .replace("GUEY", "GUEX")
        .replace("PUTA", "PUTX")
        .replace("JOTO", "JOTX")
        .replace("PUTO", "PUTX")
        .replace("KACA", "KACX")
        .replace("QULO", "QULX")
        .replace("KACO", "KACX")
        .replace("RATA", "RATX")
        .replace("KAGA", "KAGX")
        .replace("RUIN", "RUIX")
        .replace("KAGO", "KAGX");
      return palabra;
    },
    anexo1(letra) {
      letra = letra.toUpperCase();
      letra = letra
        .replace(" ", "00")
        .replace("0", "00")
        .replace("1", "01")
        .replace("2", "02")
        .replace("3", "03")
        .replace("4", "04")
        .replace("5", "05")
        .replace("6", "06")
        .replace("7", "07")
        .replace("8", "08")
        .replace("9", "09")
        .replace("&", "10")
        .replace("A", "11")
        .replace("B", "12")
        .replace("C", "13")
        .replace("D", "14")
        .replace("E", "15")
        .replace("F", "16")
        .replace("G", "17")
        .replace("H", "18")
        .replace("I", "19")
        .replace("J", "21")
        .replace("K", "22")
        .replace("L", "23")
        .replace("M", "24")
        .replace("N", "25")
        .replace("O", "26")
        .replace("P", "27")
        .replace("Q", "28")
        .replace("R", "29")
        .replace("S", "32")
        .replace("T", "33")
        .replace("U", "34")
        .replace("V", "35")
        .replace("W", "36")
        .replace("X", "37")
        .replace("Y", "38")
        .replace("Z", "39")
        .replace("Ñ", "40");
      return letra;
    },
    nombreCompuesto() {
      console.log("LLEGA DIRECTO" + this.name);
      let aux = this.name.toUpperCase();
      aux = aux.replace("MARIA ", "").replace("JOSE ", "");
      console.log("NOMBRE COMPUESTO" + aux);
      return this.quitaArticulos(aux);
    },
    answer() {
      this.rfc = "";
      if (this.auxSurname == "") {
        this.rfc += this.auxLastName.substr(0, 1);
        var l = this.auxLastName.length;
        var c;
        if (l > 1) {
          for (var i = 1; i < l; i++) {
            c = this.auxLastName.charAt(i);
            if (this.vocales(c)) {
              this.rfc += c;
              break;
            }
          }
          this.rfc += this.auxName.substr(0, 2);
        } else {
          c = "X";
          this.rfc += c;
          this.rfc += this.auxName.substr(0, 2);
        }
      } else if (this.auxLastName == "") {
        this.rfc += this.auxSurname.substr(0, 1);
        var l = this.auxSurname.length;
        var c;
        if (l > 1) {
          for (var i = 1; i < l; i++) {
            c = this.auxSurname.charAt(i);
            if (this.vocales(c)) {
              this.rfc += c;
              break;
            }
          }
          // rfc += apellidoMaterno.substr(0, 1);
          this.rfc += this.auxName.substr(0, 2);
        } else {
          c = "X";
          this.rfc += c;
          this.rfc += this.auxName.substr(0, 2);
        }
      } else {
        this.rfc += this.auxSurname.substr(0, 1);
        var l = this.auxSurname.length;
        var c;
        if (l > 1) {
          for (var i = 1; i < l; i++) {
            c = this.auxSurname.charAt(i);
            if (this.vocales(c)) {
              this.rfc += c;
              break;
            }
          }
          this.rfc += this.auxLastName.substr(0, 1);
          this.rfc += this.auxName.substr(0, 1);
        } else {
          this.rfc += this.auxLastName.substr(0, 1);
          this.rfc += this.auxName.substr(0, 2);
        }
      }
      this.rfc += this.date.substr(2, 2);
      this.rfc += this.date.substr(5, 2);
      this.rfc += this.date.substr(8, 2);
      this.rfc = this.palabraInconveniente(this.rfc);
      this.curp = this.rfc;
      console.log("RFC CREADO" + this.rfc);
    },

    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    listarPeriodicidad() {
      this.show = true;
      axios
        .get(Server + "/periodicidadesPago")
        .then((response) => {
          this.show = false;
          this.periodicities = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    listarRegimen() {
      this.show = true;
      axios
        .get(Server + "/regimen")
        .then((response) => {
          this.show = false;
          this.regimes = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    regresar() {
      this.$router.push("/employeesList");
    },
    obtenerAreasPuestos() {
      this.areas = [];
      this.show = true;
      axios
        .get(Server + "/areas")
        .then((response) => {
          this.show = false;
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (value.empresaId == this.enterprise) {
              this.areas.push({
                id: value.id,
                nombreArea: value.nombreArea,
              });
            }
          });
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
      this.jobs = [];
      this.show = true;
      axios
        .get(Server + "/puestos")
        .then((response) => {
          this.show = false;
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (value.empresaId == this.enterprise) {
              this.jobs.push({
                id: value.id,
                nombrePuesto: value.nombrePuesto,
              });
            }
          });
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
      this.branches = [];
      this.show = true;
      axios
        .get(Server + "/sucursales/por-empresa/" + this.enterprise)
        .then((response) => {
          this.show = false;
          this.branches = response.data;
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
    },

    previewFiles(event) {
      this.errors = [];
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");

      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        this.selectedFile = event.target.files[0];
      }
    },

    resetFile() {
      this.$refs.fileUploadPerfilEdit.value = "";
    },

    procesarExcel: function () {
      this.errors = [];
      var data = new FormData();
      data.append("idEmpresa", this.enterprise);
      data.append("excel", this.selectedFile, this.selectedFile.name);
      this.show = true;
      axios
        .post(Server + "/empleados/instalador/cargar/excel-plantilla-completa", data, {
        //.post(Server + "/empleados/instalador/cargar/excel", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.show = false;
          if (response.status == 200) {
            this.message="Carga de Empleados";
            this.respuesta = "Archivo procesado con éxito";
            this.confirmation = true;
          } else {
            this.titulo = "Archivo inválido";
            this.errors.push(
              "Por favor verifica los datos ingresados en el archivo excel."
            );
            this.error = true;
          }
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.titulo = "Archivo inválido";
          this.errors.push(
            "Por favor verifica los datos ingresados en el archivo excel."
          );
          this.error = true;
        });
    },

    listarBancos() {
      this.show = true;
      axios
        .get(Server + "/bancos")
        .then((response) => {
          this.show = false;
          this.banks = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    listarContratos() {
      this.show = true;
      axios
        .get(Server + "/contratos")
        .then((response) => {
          this.show = false;
          this.contracts = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    listarJornadas() {
      this.show = true;
      axios
        .get(Server + "/jornadas")
        .then((response) => {
          this.show = false;
          this.days = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
      this.show = true;
      axios
        .get(Server + "/riesgosPuesto")
        .then((response) => {
          this.show = false;
          this.risks = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    validacionCfdi() {
      this.errors = [];
      this.message = "CFDI";
      if (this.labor == "" || this.labor == " ") {
        this.errors.push("Se debe especificar la antigüedad.");
      }
      if (this.contract == "" || this.contract == 0) {
        this.errors.push("Se debe especificar el tipo de contrato.");
      }
      if (this.day == "" || this.day == 0) {
        this.errors.push("Se debe especificar el tipo de jornada.");
      }
      if (this.risk == "" || this.risk == 0) {
        this.errors.push("Se debe especificar el riesgo del puesto.");
      }
      if (this.union == "" || this.union == 0) {
        this.errors.push("Se debe especificar el sindicato.");
      }
      if (this.regime == 0 || this.regime == "") {
        this.errors.push("Se debe especificar el régimen.");
      }
      if (this.periodicity == "" || this.periodicity == 0) {
        this.errors.push("Se debe especificar la periodicidad del pago.");
      }
      this.validaCount();
      this.validaKey();
      if (this.bank == 0 || this.bank == "") {
        this.errors.push("Se debe especificar el Banco.");
      }
      if (this.nomina == 0 || this.nomina == "") {
        this.errors.push("Se debe especificar el anticipo.");
      }
      if (this.errors.length == 0) {
        this.message = "Alerta";
        this.respuesta = "Esta seguro de la almacenar el empleado.";
        this.advice = true;
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    cancelar() {
      this.enterprise = 0;
      this.name = "";
      this.surname = "";
      this.lastName = "";
      this.date = "";
      this.rfc = "";
      this.imss = "";
      this.job = 0;
      this.area = 0;
      this.branch = 0;
      this.dateAdmission = "";
      //data cfdi

      this.labor = "";
      this.contract = 0;
      this.day = 0;
      this.risk = 0;
      this.union = 2;
      this.regime = 0;
      this.periodicity = 0;
      //data bank
      this.bank = 0;
      this.count = "";
      this.key = "";
      this.nomina = 2;
      //data CFDI

      this.$router.push("/employeesList");
    },
    guardar() {
      this.advice = false;
      this.errors = [];
      this.show = true;
      axios
        .post(Server + "/empleados/instalador", {
          EmpresaId: this.enterprise,
          Nombre: this.name,
          ApellidoPaterno: this.surname,
          ApellidoMaterno: this.lastName,
          FechaNacimiento: this.date,
          CURP: this.curp,
          RFC: this.rfc,
          NSS: this.imss,
          PuestoId: this.job,
          AreaId: this.area,
          SucursalId: this.branch,
          FechaAdmision: this.dateAdmission,
          Sueldo: parseFloat(this.pay),
        })
        .then((response) => {
          this.show = false;
          if (response.status == 200) {
            this.enterprise = "";
            this.employeeNumber = "";
            this.name = "";
            this.surname = "";
            this.lastName = "";
            this.rfc = "";
            this.imss = "";
            this.job = 0;
            this.area = 0;
            this.branch = 0;
            this.dateAdmission = "";
            this.labor = "";
            //data CFDI
            this.contract = 0;
            this.day = 0;
            this.risk = 0;
            this.union = 2;
            this.regime = 0;
            this.periodicity = 0;
            //data Bank
            this.count = "";
            this.bank = 0;
            this.key = "";
            this.nomina = 2;
            this.message = "Confirmación";
            this.respuesta = "El Empleado fue almacenado con éxito";
            this.confirmation = true;
          } else {
            this.errors.push(
              "Por favor comprueba la información del empleado."
            );
            this.respuesta = "Error:";
            this.error = true;
          }
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.errors.push("Por favor comprueba la información del empleado.");
          this.respuesta = "Error:";
          this.error = true;
        });
    },
    aux() {
      this.confirmation = false;
      this.$router.push("/employeesList");
    },
    descargaExcel() {
      this.show = true;
      axios(
        {
          url:Server + "/empleados/instalador/plantilla-completa-excel/"+this.enterprise,
          //url: Server + "/empleados/instalador/plantilla/" + this.enterprise,
          method: "GET",
          responseType: "blob",
        },
        { useCredentails: true }
      ) // CORS
        .then((response) => {
          this.show = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var fecha = new Date();
          link.setAttribute(
            "download",
            "Empleados" + fecha.getTime() + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.show = false;
        });
    },
  },
  created() {
    this.listarPeriodicidad();
    this.listarRegimen();
    this.nombre();
    this.listar();
    this.listarContratos();
    this.listarJornadas();
    this.listarBancos();
  },
};
</script>
